// @ts-nocheck

// biome-ignore lint/suspicious/noImplicitAnyLet: none
let Clarity;
let clarityLoaded = false;

export function clarity(userConfig: { projectId: string } = {}) {
	const config = {
		...userConfig,
	};

	return {
		name: 'microsoft-clarity',
		config,

		/**
		 * Injects Microsoft Clarity script and initializes it
		 */

		initialize: async ({ config }: { config: { projectId: string } }) => {
			const { projectId } = config;
			if (!projectId || clarityLoaded) return;

			/* Load Clarity */
			await import('@microsoft/clarity')
				// biome-ignore lint/suspicious/noAssignInExpressions: none
				.then((module) => (Clarity = module.default))
				.then(() => {
					if (!clarityLoaded) {
						Clarity.init(projectId);
						clarityLoaded = true;
					}
				});
		},

		/**
		 * Track a page view
		 */
		page: ({ payload }) => {
			if (!clarityLoaded) return;

			Clarity.event(`PageView ${payload.properties?.page_name || payload.properties?.title}`);
		},

		/**
		 * Track a custom event
		 */

		// biome-ignore lint/suspicious/noExplicitAny: should be any
		track: ({ payload }: { payload: { event: string; properties: Record<string, any> } }) => {
			if (!clarityLoaded) return;
			const { event } = payload;
			Clarity.event(event);
		},

		/**
		 * Identify a user
		 */
		identify: ({ payload }) => {
			if (!clarityLoaded) return;
			Clarity.identify(payload.userId);
		},

		/**
		 * Return whether the pixel script has loaded
		 */
		loaded: () => clarityLoaded,
	};
}
